export const isError = (maybeError: unknown): maybeError is Error =>
  typeof maybeError === "object" &&
  maybeError !== null &&
  "message" in maybeError &&
  "name" in maybeError;
